import React from "react";
import {
  Container,
  Row,
  Spinner,
} from "reactstrap";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

import DashboardWidgets from "./DashboardWidgets";
import BookingActivity from "./BookingActivity";
import ChannelDistribution from "./ChannelDistribution";
import ChannelHealth from "./ChannelHealth";
import ChannelStatus from "./ChannelStatus";
import MappingStatus from "./MappingStatus";
import OccupancyWidget from "./OccupancyWidget";
import RecentSyncLogs from "./RecentSyncLogs";
import SyncStatusChart from "./SyncStatusChart";

import useDashboardData from "./useDashboardData";

const ChannelDashboard = () => {
  document.title =
    "HMS | Channel Manager Dashboard";

  const {
    data,
    loading,
    refresh,
  } = useDashboardData();

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center mt-5">
            <Spinner color="primary" />
          </div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <BreadCrumb
            title="Channel Manager"
            pageTitle="Dashboard"
          />

          {/* KPI WIDGETS */}
          <Row>
            <DashboardWidgets
              channels={data.channels}
              syncDashboard={data.syncDashboard}
              roomMappings={data.mappings}
              bookingLogs={data.bookingLogs}
              restrictions={data.restrictions}
              inventoryLogs={data.inventoryLogs}
            />
          </Row>

          {/* CHARTS */}
          <Row>

            <SyncStatusChart
              dashboard={
                data.syncDashboard
              }
            />

            <ChannelHealth
              channels={
                data.channels
              }
            />

          </Row>

          {/* OPERATIONS */}
          <Row className="mt-3">
            <OccupancyWidget
              inventory={
                data.inventory
              }
            />

            <BookingActivity
              bookings={
                data.bookingLogs
              }
            />

            <MappingStatus
              mappings={
                data.mappings
              }
            />

          </Row>

          {/* BOOKING DISTRIBUTION */}
          <Row className="mt-3">

            <ChannelDistribution
              channels={
                data.channels
              }
            />

            <ChannelStatus
              channels={
                data.channels
              }
              syncLogs={
                data.syncLogs
              }
            />

          </Row>

          {/* SYNC LOGS */}
          <Row className="mt-3">

            <RecentSyncLogs
              logs={
                data.syncLogs
              }
            />

          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default ChannelDashboard;